import useSWR from 'swr'
import API from '../../../utils/api'
import { useToken } from '../auth/token'

let page = 1
let search = ''
let KEY: string | null = null

export function usePopUp() {
	const { data: token } = useToken()

	if (page > 0) {
		KEY = `/popup/list?page=${page}&search=${search}`
	}

	const { data, mutate } = useSWR<any>(
		KEY ? KEY : null,
		async () => {
			console.log('KEY', KEY)
			const response = await API.get(KEY + '', token + '', {})
			return response?.result
		},
		{ dedupingInterval: 10000 }
	)

	return {
		data,
		search,
		mutate: async (value?: any) => {
			if (value) {
				page = value
			}
			return mutate()
		},
		searchApi: async (value?: any) => {
			if (value !== undefined) {
				search = value
			}
			page = 1
			KEY = `/popup/list?page=${page}&search=${search}`
			return mutate()
		},
		createPopUp: async (value: any) => {
			const res = await API.send('POST', '/popup/post', token + '', value)

			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
		deletePopUp: async (id?: any) => {
			const res = await API.send('DELETE', `/popup/${id}`, token, {})

			if (res?.message === 'success') {
				console.log(res)
				return mutate()
			} else {
				return () => {}
			}
		},
		updatePopUp: async (value: any) => {
			const res = await API.send(
				'PUT',
				`/popup/${value.id}`,
				token + '',
				{
					title: value?.title,
					content: value?.content,
					images: value?.images,
					mobile: value?.mobile,
					x: value?.x,
					y: value?.y,
					width: value?.width,
					height: value?.height,
					startdate: value?.startdate,
					enddate: value?.enddate,
					active: value?.active,
					group_id: value?.group_id,
				}
			)

			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
	}
}
